import {AppSettings} from "../../app-settings";
/* tslint:disable */
declare var ga;
export class GoogleAnalytics {
    constructor() {
        try {
            ((i:any, s, o, g, r?, a?, m?) => {
                i.GoogleAnalyticsObject = r;
                i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }, i[r].l = 1 * (<any>new Date());
                a = s.createElement(o),
                    m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m);
            })(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");
            ga("create", AppSettings.GoogleAnalytics, "auto");
            ga("require", "linkid", "linkid.js");
        } catch (ex) {
            dev.log("No google analytics - probably offline.");
        }
    }

    public trackSearch(query: string) {
         ga('send', 'event', 'Application', 'Search', 'Request', { 'query': query });
         ga('send', 'pageview');
    }

    public trackDocument(name: string) {
        ga('send', 'event', 'Application', 'Document', 'Request', { 'doc': name });
        ga('send', 'pageview');
    }

    public trackPrecedentMap(name: string) {
        ga('send', 'event', 'Application', 'Precedent Map', 'Request', { 'doc': name });
        ga('send', 'pageview');
    }
}

  



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/google-analytics.ts